import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { ForEmployersPage } from './pages/ForEmployersPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
import { RecruitmentSafetyPage } from './pages/RecruitmentSafetyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { ModernSlaveryStatementPage } from './pages/ModernSlaveryStatementPage';
// ScrollToTop component to handle scroll restoration
import { useLocation } from 'react-router-dom';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to ensure the target element is mounted
      const id = hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        } else {
          window.scrollTo(0, 0);
        }
      }, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="33oi0r16z0wuw">
      <ScrollToTop data-id="element-1" data-mp="38m1fs3bhtdnw" />
      <div className="flex flex-col min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-2" data-mp="38li8dgjgy7o4">
        <Navbar data-id="element-3" data-mp="3dle1gkqmoeow" />
        <main className="flex-grow" data-id="element-4" data-mp="3dlw727z6k59h">
          <Routes data-id="element-5" data-mp="3dm5vvs8ho6dl">
            <Route path="/" element={<HomePage data-id="element-7" data-mp="nw2cw89b1us5" />} data-id="element-6" data-mp="nvj4bi5joiqs" />
            <Route path="/about" element={<AboutPage data-id="element-9" data-mp="nxn4bp0boxls" />} data-id="element-8" data-mp="nur948fv0n11" />
            <Route path="/services" element={<ServicesPage data-id="element-11" data-mp="stkok6epio3u" />} data-id="element-10" data-mp="sudmchvou39u" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-13" data-mp="3686fj9n0kvj" />} data-id="element-12" data-mp="swqchiblnjxz" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-15" data-mp="38ktgau95lfg" />} data-id="element-14" data-mp="356sn718lka4" />
            <Route path="/employers" element={<ForEmployersPage data-id="element-17" data-mp="3uc9km0owfule" />} data-id="element-16" data-mp="3udax89lkcp58" />
            <Route path="/contact" element={<ContactPage data-id="element-19" data-mp="d57d4waue6fw" />} data-id="element-18" data-mp="3uf5g7id9y76o" />
            <Route path="/blog" element={<BlogPage data-id="element-21" data-mp="d2bibguajxvo" />} data-id="element-20" data-mp="d45rxz0443kg" />
            <Route path="/recruitment-safety" element={<RecruitmentSafetyPage data-id="element-23" data-mp="864atjm8yebm" />} data-id="element-22" data-mp="85ul7x54696g" />
            <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-25" data-mp="3gklc07duzo96" />} data-id="element-24" data-mp="3gle9ehqxh1en" />
            <Route path="/terms" element={<TermsOfServicePage data-id="element-27" data-mp="3bmbf9schkflg" />} data-id="element-26" data-mp="3glnxu0wbr0i8" />
            <Route path="/modern-slavery-statement" element={<ModernSlaveryStatementPage data-id="element-29" data-mp="3qbpo8zc5gv0b" />} data-id="element-28" data-mp="3bncqpxxez43p" />
          </Routes>
        </main>
        <Footer data-id="element-30" data-mp="3lkr5lt3ovktw" />
      </div>
    </Router>;
}